import { createAction } from '@reduxjs/toolkit'

/**
 * Команды фичи — plain actions (F05). UI вызывает actions binding-а, binding
 * dispatch-ит команду, listener исполняет её через порты. Reducer команду не
 * обрабатывает: запросы и таймеры живут в listener, не в reducer (D-063).
 */
export const resourcesReloadRequested = createAction<{ resourceId: string | null }>(
  'platform/resources/reloadRequested',
)
